import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getCesionById, hasAnyCesion } from "./Cesion.service"

export function useCesionById(id: string | undefined) {
  const queryClient = useQueryClient()
  const { data: cesionById, isLoading: cesionByIdIsLoading } = useQuery({
    queryKey: ["getCesionById", id],
    queryFn: () => getCesionById(id ?? ""),
    enabled: Boolean(id),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60 * 20,
  })
  const cesionByIdInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getCesionById", id] })

  return {
    cesionById,
    cesionByIdIsLoading,
    cesionByIdInvalidation,
  }
}

export function useIsFirstCesion(id?: string) {
  const queryClient = useQueryClient()

  const {
    data: isFirstCesionData,
    isLoading: isFirstCesionIsLoading,
    error: isFirstCesionError,
    refetch: isFirstCesionRefetch,
  } = useQuery<boolean>({
    queryKey: ["isFirstCesion", id],
    queryFn: () => hasAnyCesion(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2, // 2 hours
    retry: false,
  })

  const invalidateIsFirstCesion = () =>
    queryClient.invalidateQueries({ queryKey: ["isFirstCesion"] })

  return {
    isFirstCesion: isFirstCesionData,
    isFirstCesionIsLoading,
    isFirstCesionError,
    invalidateIsFirstCesion,
    isFirstCesionRefetch,
  }
}
